import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { PaymentService } from '../payment/payment.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private authService: AuthService, private router: Router, private payService: PaymentService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {


    const loggedOutAccessOnly: boolean = route.data?.['loggedOutAccessOnly'] || false;
    const loggedInAccessOnly: boolean = route.data?.['loggedInAccessOnly'] || false;

    const authResponse = await this.authService.getAuthResponse();

    if (!authResponse || !authResponse.authenticated) {
      if (loggedOutAccessOnly) return true;
      return this.handleRoute('/', state);
    }

    /*
   Check if there is a token and if user need to verify email or has restrictions
   */


    if (authResponse.disabled) {
      return this.handleRoute('/account-disabled', state);
    }

    if (loggedInAccessOnly) {
      return true;
    }

    if (!authResponse.verified) {
      return this.handleRoute('/email-confirmation', state);
    }

    if (loggedOutAccessOnly) {
      return this.handleRoute('/sub-pricing', state);
    }

    if (!authResponse.subStatus || !authResponse.subExpires) {
      return this.router.createUrlTree(['/settings'], { queryParams: { tab: 'billing' } });
    }

    return true;

  }

  private handleRoute(path: string, state: RouterStateSnapshot): boolean | UrlTree {
    if (state.url !== path) {
      return this.router.parseUrl(path);
    }
    return true;
  }




}
